import React, { useState } from "react";
import { Link } from "react-router-dom";

export const SAVE_THRESHOLD = 5;

// Same pen icon the "Co-sign artist" button uses in the ranking table, so a
// new user can spot the button the banner is talking about.
const coSignIcon = `${process.env.PUBLIC_URL || ""}/assets/artist-ranking-pen-hollow.svg`;

// Two-stage nudge shown on the home rankings table: "save 5 to unlock
// ranking" before the threshold, then "you have artists to rank" once
// there are saved artists not yet placed in the user's ranking.
function RankingNudgeBanner({ savedCount, pendingCount, onRankNow }) {
  const [dismissed, setDismissed] = useState(false);
  if (dismissed) return null;

  if (savedCount < SAVE_THRESHOLD) {
    const remaining = SAVE_THRESHOLD - savedCount;
    return (
      <div className="ranking-nudge-banner">
        <span>
          Co-sign
          <img src={coSignIcon} alt="" aria-hidden="true" className="ranking-nudge-cosign-icon" />
          {remaining} more artist{remaining === 1 ? "" : "s"} to begin ranking them ({savedCount}/{SAVE_THRESHOLD})
          <Link to="/help#ranking-artists" className="info-icon-link" title="What does ranking artists mean?">ⓘ</Link>
        </span>
        <button className="ranking-nudge-dismiss" onClick={() => setDismissed(true)} aria-label="Dismiss">
          ×
        </button>
      </div>
    );
  }

  if (pendingCount > 0) {
    return (
      <div className="ranking-nudge-banner ranking-nudge-banner-ready">
        <span>
          {pendingCount} artist{pendingCount === 1 ? "" : "s"} ready to rank!
          <Link to="/help#ranking-artists" className="info-icon-link" title="What does ranking artists mean?">ⓘ</Link>
        </span>
        <button className="ranking-nudge-rank-btn" onClick={onRankNow}>
          Rank Now
        </button>
        <button className="ranking-nudge-dismiss" onClick={() => setDismissed(true)} aria-label="Dismiss">
          ×
        </button>
      </div>
    );
  }

  return null;
}

export default RankingNudgeBanner;
